import type { TableColumnsType } from 'antd';
import type { UserType } from './Users.types.ts';
import * as Yup from 'yup';
import { HomeOutlined } from '@ant-design/icons';
import i18n from '../../utils/i18n.ts';
import { checkUser } from './Users.services.ts';

const ROLES = {
  1: i18n.t('form.option.specification-approver'),
  2: i18n.t('form.option.company-agreement-approver'),
  3: i18n.t('form.option.implementation-approver'),
  4: i18n.t('form.option.administrator'),
  5: i18n.t('form.option.auditor'),
} as const;

export const USERS_FORM = 'UsersForm';

export const BREADCRUMBS = [
  {
    href: '/',
    title: <HomeOutlined />,
  },
  {
    href: '/',
    title: i18n.t('common.portal'),
  },
  {
    href: '/admin',
    title: i18n.t('pages.admin.title'),
  },
  {
    title: i18n.t('pages.admin.module.users'),
  },
];

export const USERS_COLUMNS: TableColumnsType<UserType> = [
  {
    title: i18n.t('pages.users.name'),
    dataIndex: 'displayName',
  },
  {
    title: i18n.t('pages.users.email'),
    dataIndex: 'email',
  },
  {
    title: i18n.t('pages.users.roles'),
    dataIndex: 'roles',
    render: (value: { id: number; type: number }[]) =>
      value
        .map((role: { id: number; type: number }) => ROLES[role.type as keyof typeof ROLES])
        .join(', ') || 'No roles',
  },
];

export const USERS_FORM_SCHEMA = Yup.object().shape({
  id: Yup.string(),
  name: Yup.string(),
  email: Yup.string().required(i18n.t('error.validation.required-email')),
  user: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Entra ID is required'),
      }),
    )
    .min(1, i18n.t('error.validation.required-name'))
    .nullable()
    .required(i18n.t('error.validation.required.name'))
    .test('unique-group', i18n.t('error.validation.exist-user'), async (value, ctx) => {
      if (ctx.parent?.id) return true;
      if (!value) return true;
      if (value[0]?.value) {
        const res = await checkUser(value[0]?.value);
        return res.exists;
      }
      return true;
    }),
});

export const USERS_INITIAL_FORM_VALUES = {
  id: '',
  name: '',
  email: '',
  roles: [],
  user: [],
};
